import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import axios from 'axios';
import { useSelector } from "react-redux";

const Alert = (props: AlertProps) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const Comment = ({ id, onclick }) => {
  const [comment, setComment] = useState<String>('');
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState('');
  const { auth } = useSelector((state: any) => {
    return state;
  });

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const submitComment = () => {
    const cmt = {
      message: comment,
    };
    const url = `https://betastore-staging.herokuapp.com/api/v1/products/${id}/comment`;
    if (navigator.onLine) {
      axios
        .post(url, cmt, {
        headers: { 
        'Authorization': `Bearer ${auth.token}`,
      },})
        .then((res) => {
          setMsg('Comment submitted successfully');
        })
        .catch((err) => {
          setMsg('An error occured');
        });
      setOpen(true);
      setComment('');
    } else {
      const dataToStoreToLocalStorage = {
        url,
        cmt,
        token: auth.token
      }
      if(localStorage.getItem('comment')){
        const prev = JSON.parse(localStorage.getItem('comment'));
        prev.push(dataToStoreToLocalStorage);
        window.localStorage.setItem('comment', JSON.stringify(prev));
      }else{
        const data = [];
        data.push(dataToStoreToLocalStorage);
        window.localStorage.setItem('comment', JSON.stringify(data));
      }
      setMsg(
        "You're offline, your data will be updated once connection has been established"
      );
      setOpen(true);
    }
  };
  return (
    <>
      <DialogTitle id="form-dialog-title">Comment</DialogTitle>
      <DialogContent>
        <TextField
          id="outlined-multiline-static"
          label="Comment"
          autoFocus
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onclick} color="primary">
          Cancel
        </Button>
        <Button onClick={submitComment} color="primary">
          Submit comment
        </Button>
      </DialogActions>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          {msg}
        </Alert>
      </Snackbar>
    </>
  );
};
export default Comment;
